<template>
  <div class="price-list-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Cennik</h1>
      <div class="header-actions">
        <button
            v-if="subscriptions.length <= 10"
            @click="$router.push('/admin-profile/price-list/add')"
            class="btn-primary"
        >
          + Dodaj plan
        </button>
      </div>
    </div>

    <div class="section-card position-relative">
      <div class="section-card-header">
        <HintComponent page-key="admin_panel_price_list" :absolute="true"/>
        <h2>Lista planów subskrypcji</h2>
        <div class="meta-row">
          <span class="plans-counter">Liczba planów: <b>{{ subscriptions.length }}</b>/10</span>
          <button class="btn-outline" @click="getSubscriptions">Odśwież</button>
        </div>
      </div>

      <div v-if="subscriptions.length > 0" class="plans-grid">
        <SubPlanCard
            v-for="sub in subscriptions"
            :key="sub.id"
            :id="sub.id"
            :name="sub.name"
            :subscription-m="sub.subscriptionM"
            :additional-s-m-s="sub.additionalSMS"
            :additional-user-m="sub.additionalUserM"
            :free-users="sub.freeUsers"
            :free-s-m-s="sub.freeSMS"
            :period="sub.period"
            @refreshSubscriptions="getSubscriptions"
        />
      </div>

      <div v-else class="empty-state">
        <p>Brak planów do wyświetlenia.</p>
      </div>
    </div>
  </div>
</template>

<script>
import SubPlanCard from '@/components/SpecialComponents/SubPlanCard.vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'SepcsEdit',
  components: {HintComponent, SubPlanCard },
  setup() {
    return {
      authStore: useAuthStore(),
    };
  },
  data() {
    return {
      subscriptions: [],
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getSubscriptions();
  },
  methods: {
    getSubscriptions() {
      axios.post('/SubscriptionSearch', {
        page: 1,
        limit: 10,
      }).then(res => {
        this.subscriptions = res.data.items || [];
      }).catch(() => {
        this.subscriptions = [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
.price-list-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.plans-counter {
  font-size: 1.4rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 6px 12px;
}

.plans-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 480px) {
  .price-list-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .header-actions {
    width: 100%;
  }
}
</style>